import React from 'react';
import {Spin}  from 'antd';
import { Pie } from '@ant-design/plots';
import { DonutPropsType } from '../../src/atoms/internalDashboardAtoms';
import axiosClient from '../api/axiosClient';
import { useQuery } from '@tanstack/react-query';

const currencyMap: any = { 43: '€', 46: '£', 142: '$' };

const InternalDonutTabContent = (props: DonutPropsType) => {
    const managedCustomersKey = (props.managed_customers ?? []).join(',');
    const canFetch = Boolean(
        props.platform && props.metric && props.dimension && props.managed_customers
    );

    const { data: filteredData, isLoading: loading } = useQuery({
        queryKey: [
            'donutdata',
            props.platform,
            props.metric,
            props.dimension,
            props.startDate,
            props.endDate,
            managedCustomersKey,
            props.metric_type
        ],
        queryFn: async () => {
            const res = await axiosClient.portal.post('/api/employees/getdonutdata', props);
            return res.data;
        },
        enabled: canFetch,
        staleTime: Infinity,
        cacheTime: Infinity
    });

    return (
        <>
            {filteredData != null && !loading && (
                <Pie
                    angleField={'metric'}
                    colorField={'dimension'}
                    data={filteredData.data}
                    appendPadding={[10, 150, 0, 0]}
                    radius={1}
                    innerRadius={0.64}
                    meta={{
                        metric: {
                            formatter: (value) => {
                                let currency = currencyMap[filteredData.currency];

                                let returnValue = ((value as number) || 0)?.toLocaleString('el-GR') + (props.valMeasurement ? props.valMeasurement : '');
                                // Add currency symbol at the end of the value if needed
                                if (props.metric == 'Revenue') {
                                    returnValue = returnValue + (currency ? ' ' + currency : '');
                                }
                                return returnValue;
                            }
                        }
                    }}
                    width={500}
                    height={400}
                    padding={0}
                    label={{
                        type: 'inner',
                        offset: '-50%',
                        style: {
                            textAlign: 'center'
                        },
                        autoRotate: false,

                        formatter: (data, mappingData) => {
                            let currency = currencyMap[filteredData.currency];
                            let formNumber = new Intl.NumberFormat('en-US', { notation: 'compact' });
                            let returnValue;
                            // Add currency symbol at the end of the value if needed
                            if (props.metric == 'Revenue') {
                                returnValue = currency + ' ' + formNumber.format(+data.metric);
                            } else {
                                returnValue = formNumber.format(+data.metric);
                            }
                            return returnValue;
                        }
                    }}
                    statistic={{
                        title: {
                            offsetY: -4,
                            style: {
                                fontSize: '18px'
                            }
                        },
                        content: {
                            offsetY: 4,
                            style: {
                                // if its from jwplayer watch time 26px else 32px
                                fontSize: props.metric == 'Watch Time' ? '26px' : '32px',
                            }
                        }
                    }}
                    interactions={[
                        {
                            type: 'element-selected'
                        },
                        {
                            type: 'element-active'
                        },
                        {
                            type: 'pie-statistic-active'
                        }
                    ]}
                />
            )}

            {loading && <Spin />}
        </>
    );
};

export default InternalDonutTabContent;
